import React, { createContext, useContext, useState, useCallback } from "react";

export const CONTACT = {
  name: "Sushma Harsh Timmaraju",
  phone: "+41 76 766 76 43",
  phoneRaw: "+41767667643",
  whatsapp: "41767667643",
  email: "sushmahomeopathy@gmail.com",
  address: "6, rue du Temple, 1814 La Tour-de-Peilz, Suisse",
  mapsQuery: "6+rue+du+Temple+1814+La+Tour-de-Peilz+Switzerland",
};

export const content = {
  fr: {
    nav: { about: "Á propos", expertise: "Expertise", journey: "Parcours", location: "Cabinet", contact: "Contact", faq: "FAQ", book: "Prendre RDV" },
    hero: {
      kicker: "Homeopathie Classique · Riviera Vaudoise",
      title: ["Soins homeopathiques", "individualises pour une", "sante & vitalite durables"],
      subtitle: "Cabinet à La Tour-de-Peilz — au service des patients de Vevey, Montreux, Lausanne et de toute la Suisse.",
      ctaBook: "Prendre une consultation",
      ctaCall: "Appeler / WhatsApp",
      credential: "Homéopathe classique ( ASCA)",
    },
    marquee: "SOIN INDIVIDUALISE · STANDARD SUISSE · SANTE HOLISTIQUE · APPROCHE RACINE · FORCE VITALE",
    about: {
      label: "Á propos",
      title: "Une ecoute profonde, une approche qui traite la racine",
      p1: "Sushma Harsh Timmaraju est un homeopathe classique ASCA accrédité , titulaire Médecin Homéopathe en Inde . Elle accompagne chaque patient avec rigueur clinique, chaleur et une profonde attention a la personne dans sa globalite.",
      p2: "Sa pratique repose sur l'homeopathie classique uniciste: un remède unique, choisi avec precision apres une anamnese complete — physique, mentale et emotionnelle — pour stimuler la force vitale et la guerison durable.",
      stats: [
        { n: "ASCA", l: "Praticienne agreee" },
        { n: "100%", l: "Approche individualisee" },
        { n: "FR / EN", l: "Consultations bilingues" },
      ],
    },
    expertise: {
      label: "Domaines d'expertise",
      title: "Un accompagnement pour chaque etape de la vie",
      items: [
        { t: "Maladies chroniques", d: "Prise en charge des affections chroniques et recurrentes en profondeur." },
        { t: "Soutien immunitaire", d: "Renforcement des defenses naturelles et de la resilience." },
        { t: "Sante feminine", d: "Cycles, menopause, equilibre hormonal et bien-etre feminin." },
        { t: "Pediatrie & enfance", d: "Soins doux et surs adaptes aux nourrissons et aux enfants." },
        { t: "Stress & vitalite", d: "Gestion du stress, sommeil, energie et equilibre emotionnel." },
        { t: "Allergies", d: "Soulagement des terrains allergiques et sensibilites saisonnieres." },
      ],
    },
    journey: {
      label: "Le parcours patient",
      title: "Trois etapes, un chemin vers l'equilibre",
      steps: [
        { n: "01", t: "Consultation initiale approfondie", d: "Anamnese complete de votre etat physique, mental et emotionnel, dans un espace d'ecoute sans jugement." },
        { n: "02", t: "Selection du remede personnalise", d: "Approche classique du remede unique, choisi avec precision selon votre terrain individuel." },
        { n: "03", t: "Suivi & accompagnement", d: "Suivi de vos progres et de la recuperation de votre force vitale au fil des consultations." },
      ],
    },
    location: {
      label: "Cabinet & acces",
      title: "Au coeur de La Tour-de-Peilz",
      access: "Acces & stationnement",
      accessItems: [
        "A quelques minutes a pied de la gare de La Tour-de-Peilz et des arrets de bus.",
        "Stationnement disponible a proximite de la Rue du Temple.",
        "Cabinet facilement accessible depuis Vevey, Montreux et Lausanne.",
      ],
      addressLabel: "Adresse",
      directions: "Itineraire",
    },
    contact: {
      label: "Rendez-vous & demande",
      title: "Reservez votre consultation",
      intro: "Ecrivez-moi ou appelez directement. Je vous reponds personnellement dans les meilleurs delais.",
      fee: "Structure tarifaire",
      feeText: "La premiere consultation (anamnese complete) dure environ 60 a 90 minutes. Les tarifs sont communiques lors de la prise de rendez-vous.",
      insurance: "Assurances complementaires",
      insuranceText: "Prestations reconnues par les standards des assurances complementaires suisses (ASCA) selon votre couverture. Verifiez aupres de votre assurance.",
      form: { name: "Nom complet", email: "Email", phone: "Telephone", subject: "Sujet", message: "Votre message", send: "Envoyer la demande", sending: "Envoi..." },
      success: "Merci ! Votre demande a bien ete envoyee. Je vous recontacte rapidement.",
      error: "Une erreur est survenue. Merci de reessayer ou d'appeler directement.",
    },
    faq: {
      label: "Questions frequentes",
      title: "Ce qu'il faut savoir",
      items: [
        { q: "Qu'est-ce que l'homeopathie classique ?", a: "L'homeopathie classique repose sur le principe du remede unique : un seul remede, choisi avec precision selon l'ensemble de vos symptomes et de votre terrain individuel, pour stimuler la capacite naturelle de guerison du corps." },
        { q: "Combien de temps dure une consultation ?", a: "La premiere consultation dure environ 60 a 90 minutes afin de realiser une anamnese complete. Les consultations de suivi sont plus courtes, generalement 30 a 45 minutes." },
        { q: "A quoi s'attendre lors de la premiere visite ?", a: "La premiere visite est un echange approfondi sur votre sante physique, mentale et emotionnelle, votre histoire et votre mode de vie. Cette ecoute permet de choisir le remede le plus adapte a votre cas." },
        { q: "Les consultations sont-elles en francais ou en anglais ?", a: "Les consultations sont proposees en francais et en anglais, afin d'accueillir aussi bien la clientele locale que la communaute expatriee de la Riviera." },
        { q: "L'homeopathie est-elle remboursee ?", a: "Selon votre assurance complementaire (standards ASCA), une partie des consultations peut etre prise en charge. Nous vous invitons a verifier votre couverture aupres de votre assureur." },
      ],
    },
    footer: { tagline: "Homeopathie classique · Soins individualises · Riviera vaudoise", rights: "Tous droits reserves.", quick: "Navigation", contactTitle: "Contact" },
    widget: { call: "Appeler", whatsapp: "WhatsApp" },
  },
  en: {
    nav: { about: "About", expertise: "Expertise", journey: "Journey", location: "Practice", contact: "Contact", faq: "FAQ", book: "Book" },
    hero: {
      kicker: "Classical Homeopathy · Swiss Riviera",
      title: ["Individualized homeopathic", "care for lasting", "health & vitality"],
      subtitle: "Practice in La Tour-de-Peilz — serving patients in Vevey, Montreux, Lausanne and across Switzerland.",
      ctaBook: "Book a consultation",
      ctaCall: "Call / WhatsApp",
      credential: "Classical Homeopath (ASCA)",
    },
    marquee: "INDIVIDUALIZED CARE · SWISS STANDARD · HOLISTIC HEALTH · ROOT-CAUSE APPROACH · VITAL FORCE",
    about: {
      label: "About",
      title: "Deep listening, a root-cause approach to health",
      p1: "Sushma Harsh Timmaraju is an ASCA-accredited classical homeopath and a qualified Homeopathic Physician from India. She supports each patient with clinical rigour, warmth and deep attention to the whole person.",
      p2: "Her practice is grounded in classical unicist homeopathy: a single remedy, chosen with precision after a comprehensive physical, mental and emotional case-taking, to stimulate the vital force and lasting recovery.",
      stats: [
        { n: "ASCA", l: "Accredited practitioner" },
        { n: "100%", l: "Individualized approach" },
        { n: "FR / EN", l: "Bilingual consultations" },
      ],
    },
    expertise: {
      label: "Areas of expertise",
      title: "Care for every stage of life",
      items: [
        { t: "Chronic illness", d: "In-depth care for chronic and recurring conditions." },
        { t: "Immune support", d: "Strengthening natural defences and resilience." },
        { t: "Women's health", d: "Cycles, menopause, hormonal balance and wellbeing." },
        { t: "Pediatric & child wellness", d: "Gentle, safe care tailored to infants and children." },
        { t: "Stress & vitality", d: "Stress, sleep, energy and emotional balance." },
        { t: "Allergies", d: "Relief for allergic terrain and seasonal sensitivities." },
      ],
    },
    journey: {
      label: "The patient journey",
      title: "Three steps toward balance",
      steps: [
        { n: "01", t: "In-depth initial consultation", d: "Comprehensive case-taking of your physical, mental and emotional state, in a calm and judgment-free space." },
        { n: "02", t: "Customized remedy selection", d: "Classical single-remedy approach, precisely chosen for your individual constitution." },
        { n: "03", t: "Follow-up & health tracking", d: "Monitoring your progress and the recovery of your vital force across consultations." },
      ],
    },
    location: {
      label: "Practice & access",
      title: "In the heart of La Tour-de-Peilz",
      access: "Access & parking",
      accessItems: [
        "A few minutes' walk from La Tour-de-Peilz train station and bus stops.",
        "Parking available near Rue du Temple.",
        "Easily reached from Vevey, Montreux and Lausanne.",
      ],
      addressLabel: "Address",
      directions: "Directions",
    },
    contact: {
      label: "Appointment & inquiry",
      title: "Book your consultation",
      intro: "Write to me or call directly. I respond personally as soon as possible.",
      fee: "Fee structure",
      feeText: "The first consultation (comprehensive case-taking) lasts around 60 to 90 minutes. Fees are shared when booking your appointment.",
      insurance: "Complementary insurance",
      insuranceText: "Services recognised under Swiss complementary insurance standards (ASCA) depending on your coverage. Please check with your insurer.",
      form: { name: "Full name", email: "Email", phone: "Phone", subject: "Subject", message: "Your message", send: "Send inquiry", sending: "Sending..." },
      success: "Thank you! Your inquiry has been sent. I will get back to you shortly.",
      error: "Something went wrong. Please try again or call directly.",
    },
    faq: {
      label: "Frequently asked",
      title: "What to know",
      items: [
        { q: "What is classical homeopathy?", a: "Classical homeopathy rests on the single-remedy principle: one remedy, precisely chosen based on the totality of your symptoms and individual constitution, to stimulate the body's natural capacity to heal." },
        { q: "How long is a consultation?", a: "The first consultation lasts around 60 to 90 minutes for a comprehensive case-taking. Follow-up consultations are shorter, generally 30 to 45 minutes." },
        { q: "What to expect during the first visit?", a: "The first visit is an in-depth conversation about your physical, mental and emotional health, your history and lifestyle. This listening allows the most suitable remedy to be selected for your case." },
        { q: "Are consultations in French or English?", a: "Consultations are offered in both French and English, to welcome local residents as well as the Riviera's expat community." },
        { q: "Is homeopathy reimbursed?", a: "Depending on your complementary insurance (ASCA standards), part of the consultations may be covered. We invite you to check your coverage with your insurer." },
      ],
    },
    footer: { tagline: "Classical homeopathy · Individualized care · Swiss Riviera", rights: "All rights reserved.", quick: "Navigation", contactTitle: "Contact" },
    widget: { call: "Call", whatsapp: "WhatsApp" },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("fr");
  const toggle = useCallback((l) => setLang(l), []);
  return <LangContext.Provider value={{ lang, setLang: toggle, t: content[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
